import z from 'zod';

export const applicationArtistSchema = z.object({
  name: z.string(),
  id: z.string(),
  isEligible: z.boolean(),
  orionApprovalCount: z.number(),
  orionApprovalLimit: z.number(),
});
